import onSelectionChange from "../events/onSelectionChange";
import getNextRowIndexInternal from "../internal/getNextRowIndexInternal";
import singleSelectRowInternalMutatorAction from "../internal/mutators/singleSelectRowInternalMutatorAction";

import { selectRowInDirection, setExpansionForRow, onAfterSelectionChanged, } from "owa-mail-actions/lib/mailListSelectionActions";
import { lazyOnSingleSelectionChanged } from "owa-mail-mark-read-actions";
import { orchestrator } from "satcheljs";
import { createSelectMailItemDatapoint } from "owa-mail-logging/lib/utils/selectMailItemDatapointUtils";
import mailStore from "owa-mail-store/lib/store/Store";
import getListViewState from "owa-mail-list-store/lib/selectors/getListViewState";
import focusNextRowBeforeCollapse from "../utils/focusNextRowBeforeCollapse";

/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////

const defaultExport: (actionMessage: ReturnType<typeof selectRowInDirection>) => void | Promise<void> = orchestrator(selectRowInDirection, actionMessage => {
    const { tableView, selectionDirection, mailListItemSelectionSource } = actionMessage;
    createSelectMailItemDatapoint(mailListItemSelectionSource, tableView, undefined /* rowKey */, selectionDirection, mailStore().shouldExpandAllItemParts);
    // Before resetting selection, need to store currently selected row key to be marked as read
    const oldSelectedRowKey = tableView.selectedRowKeys.size == 1 ? [...tableView.selectedRowKeys.keys()][0] : undefined;
    
    const { selectedIndex, headerToFocus } = getNextRowIndexInternal(tableView, selectionDirection);
    
    // We should check if selectedIndex is within valid range
    // when user delete/move messages from Junk Mail folder, the focus was set to maillist container,
    // which caused the selectedIndex becoming invalid
    if (selectedIndex !== null && selectedIndex >= 0) {
        const rowKey = tableView.rowKeys[selectedIndex];
        // Mark the previously selected row as read
        if (oldSelectedRowKey && (rowKey !== oldSelectedRowKey || headerToFocus)) {
            lazyOnSingleSelectionChanged.importAndExecute(oldSelectedRowKey, tableView, true /* isUserNavigation */);
        }
        
        if (!headerToFocus) {
            const { expandedRowKey, focusedNodeId } = getListViewState().expandedConversationViewState;
            if (expandedRowKey && focusedNodeId) {
                focusNextRowBeforeCollapse(rowKey, mailListItemSelectionSource, expandedRowKey, focusedNodeId);
            }
            setExpansionForRow(rowKey, mailListItemSelectionSource);
        }
        singleSelectRowInternalMutatorAction(tableView, rowKey, mailListItemSelectionSource, headerToFocus);
    }
    
    // Propagate selection change event
    return onSelectionChange(tableView, true /* isUserNavigation */, mailListItemSelectionSource).then(() => {
        if (selectedIndex !== null && selectedIndex >= 0) {
            onAfterSelectionChanged(tableView.rowKeys[selectedIndex], tableView, mailListItemSelectionSource);
        }
    });
});
export default defaultExport;
